<p-toast position="top-center"></p-toast>
<p-dialog
    [(visible)]="loading"
    [showHeader]="false"
    [resizable]="false"
    [modal]="true"
    [focusOnShow]="false"
    class="progress-overlay">

    <div class="global-loading-container text-center">
        <p-progressSpinner styleClass="global-loading-spinner"></p-progressSpinner>
    </div>
</p-dialog>

<div class="row">
    <div class="col-12 tableDateRange">
         <p class="date-range">Date Range: {{date.startDate| date : 'MM/dd/yyyy | HH:mm'}} through {{date.endDate| date : 'MM/dd/yyyy | HH:mm'}}</p>
    </div>
</div>
<div class="row">
    <div class="col-12 pSelectBTN">
        <p-selectButton
          (onChange)="updateLookbackPeriod($event)" [options]="days" [(ngModel)]="selectedDays" (dateValue)="updatedDate($event)">
        </p-selectButton>
    </div>
</div>


<div class="row firstRow">
    <div class="col-12 overview-card-grid">
        <div class="row pcardRow">
            <div class="col-6">
                <p-card header="Total Records Monitored" *ngIf="!adcLoading" class="HeadLiner overview-card">
                    <div class="overview-card-content">
                        <div>
                            <h1>{{adcEhrOverViews.recordsMonitored}}</h1>
                        </div>
                        <div class="overview-card-action">
                            <p-button icon="pi pi-info" [rounded]="true" [text]="true" severity="info" (click)="showInfo()"></p-button>
                        </div>
                    </div>
                </p-card>
                <p-card header="Total Records Monitored" *ngIf="adcLoading" class="HeadLiner overview-card">
                    <div class="overview-card-loading">
                       <p-progressSpinner styleClass="w-2rem h-2rem" strokeWidth="6" fill="var(--surface-ground)" animationDuration=".5s"></p-progressSpinner>
                    </div>
                </p-card>
            </div>
            <div class="col-6">
                <p-card header="Total Variances Monitored" *ngIf="!overViewLoading" class="HeadLiner overview-card">
                    <h1>{{overViews.totalInteraction}}</h1>
                </p-card>
                <p-card header="Total Variances Monitored" *ngIf="overViewLoading" class="HeadLiner overview-card">
                    <div class="overview-card-loading">
                       <p-progressSpinner styleClass="w-2rem h-2rem" strokeWidth="6" fill="var(--surface-ground)" animationDuration=".5s"></p-progressSpinner>
                    </div>
                </p-card>
            </div>
        </div>
        <div class="row pcardRow">
            <div class="col-6">
               <p-card header="ADC Records |  EHR Records" *ngIf="!adcLoading" class="HeadLiner overview-card">
                    <h1>{{adcEhrOverViews.adc}} | {{adcEhrOverViews.ehr}}</h1>
                </p-card>
                <p-card header="ADC Records |  EHR Records" *ngIf="adcLoading" class="HeadLiner overview-card">
                    <div class="overview-card-loading">
                       <p-progressSpinner styleClass="w-2rem h-2rem" strokeWidth="6" fill="var(--surface-ground)" animationDuration=".5s"></p-progressSpinner>
                    </div>
                </p-card>
            </div>
            <div class="col-6">
                <p-card header="Unreconciled Doses Found" *ngIf="!medLoading" class="HeadLiner overview-card">
                    <div class="overview-card-content">
                      <div>
                        <h1>{{ UnaccountedData }}</h1>
                      </div>
                      <div class="overview-card-action">
                        <p-button icon="pi pi-table" styleClass="p-button-rounded p-button-text" (click)="showUnaccountedMeds()"></p-button>
                      </div>
                    </div>
                </p-card>
                <p-card header="Unreconciled Doses Found" *ngIf="medLoading" class="HeadLiner overview-card">
                    <div class="overview-card-loading">
                       <p-progressSpinner styleClass="w-2rem h-2rem" strokeWidth="6" fill="var(--surface-ground)" animationDuration=".5s"></p-progressSpinner>
                    </div>
                </p-card>
             </div>
        </div>
        <div class="row pcardRow">
            <div class="col-6">
                <p-card header="High Risk Interactions" *ngIf="!overViewLoading" class="HeadLiner overview-card">
                    <h1>{{overViews.totalHighRisk}}</h1>
                 </p-card>
                 <p-card header="High Risk Interactions" *ngIf="overViewLoading" class="HeadLiner overview-card">
                    <div class="overview-card-loading">
                       <p-progressSpinner styleClass="w-2rem h-2rem" strokeWidth="6" fill="var(--surface-ground)" animationDuration=".5s"></p-progressSpinner>
                    </div>
                </p-card>
            </div>
            <div class="col-6">
                <p-card header="High Risk Variance Rate" *ngIf="!overViewLoading" class="HeadLiner overview-card">
                    <h1>{{ overViews.totalDiscrepincyRate }}%</h1>
                 </p-card>
                 <p-card header="High Risk Variance Rate" *ngIf="overViewLoading" class="HeadLiner overview-card">
                    <div class="overview-card-loading">
                       <p-progressSpinner styleClass="w-2rem h-2rem" strokeWidth="6" fill="var(--surface-ground)" animationDuration=".5s"></p-progressSpinner>
                    </div>
                </p-card>
             </div>
        </div>
        <div class="row pcardRow">
            <div class="col-6">
               <p-card header="High Risk Verified Count" *ngIf="!verifiedLoading" class="HeadLiner overview-card">
                    <h1>{{ verifiedData.verified }}</h1>
                </p-card>
                <p-card header="High Risk Verified Count" *ngIf="verifiedLoading" class="HeadLiner overview-card">
                    <div class="overview-card-loading">
                        <p-progressSpinner
                            styleClass="w-2rem h-2rem"
                            strokeWidth="6"
                            fill="var(--surface-ground)"
                            animationDuration=".5s">
                        </p-progressSpinner>
                    </div>
                </p-card>
            </div>
            <div class="col-6">
                <p-card header="High Risk Verified Rate" *ngIf="!overViewLoading" class="HeadLiner overview-card">
                    <h1 *ngIf="!overViewLoading">{{ getverifiedRate() }}%</h1>
                 </p-card>
                 <p-card header="High Risk Verified Rate" *ngIf="overViewLoading" class="HeadLiner overview-card">
                    <div class="overview-card-loading">
                        <p-progressSpinner
                            styleClass="w-2rem h-2rem"
                            strokeWidth="6"
                            fill="var(--surface-ground)"
                            animationDuration=".5s">
                        </p-progressSpinner>
                    </div>
                </p-card>
             </div>
        </div>
    </div>
    <div class="col-md-auto align-self-center alignmentStyle">
        <p-card header="Variance Type Rates" class="variance-type-card">
            <div class="row">
                <div class="col-12">
                    <p-table
                    #globalTT
                    [value]="resolutionReport"
                    [paginator]="true"
                    [rows]="15"
                    [showCurrentPageReport]="true"
                    >
                        <ng-template pTemplate="header">
                            <tr>
                                <th [pSortableColumn]="'resolution'" class="resolution-table-header resolution-column">
                                    Variance Type
                                    <p-sortIcon field="resolution"></p-sortIcon>
                                </th>
                                <th [pSortableColumn]="'count'" class="resolution-table-header occurrence-column">
                                    Total Occurrances
                                    <p-sortIcon field="count"></p-sortIcon>
                                </th>
                                <th [pSortableColumn]="" class="resolution-table-header percent-column">
                                    Percent of Total
                                </th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-rowData>
                                <tr>
                                    <td>
                                        {{rowData.resolution}}
                                    </td>
                                    <td class="numeric-cell">
                                        {{rowData.count | number}}
                                    </td>
                                    <td class="numeric-cell">
                                        {{ getDiscrepincyRate(rowData) }}
                                    </td>
                                </tr>
                        </ng-template>
                    </p-table>
                </div>
            </div>
        </p-card>
    </div>
</div>
<div class="row secondRow">
        <p-card header="Total High Risk Variances" class="total-high-risk-card">
            <p-chart type="bar" [height]="400" [width]="1440" [data]="highRiskResolutionChartData" [options]="discrepancyCharOptions" class="total-high-risk-chart"></p-chart>
        </p-card>
</div>

<p-dialog header="Unreconciled Doses" [(visible)]="unaccountedMedTable" [style]="{width: '98vw'}" [maximizable]="true" [resizable]="true" styleClass="individual-activity-dialog" class="popUpHeader">
    <app-data-filter-pills [filterValues]="iaFilter" [deId]="deId" (filterVal)="removeFilter($event)" (filterInputs)="openFilterModuleAfterMore($event)"></app-data-filter-pills>
    <app-urc
      #varianceComponent
      *ngIf="unaccountedMedTable"
      [auditRow]="sendData()"
      [deId]="deId"
      [isAuditor]="true"
      [lookbackPeriod]="filter.duration"
    ></app-urc>
</p-dialog>

<p-dialog header="High Risk Verified Count" [(visible)]="verifiedTable" [style]="{width: '90vw'}" class="popUpHeader">
    <div class="row">
        <div class="col-12 align-self-center">
            <!-- <p-chart type="bar" [height]="320" [width]="996" [data]="verifiedChartData" [options]="verifiedOptions"></p-chart> -->
        </div>
    </div>
</p-dialog>

<p-dialog header="Total records Monitored" appendTo="body" [(visible)]="infoPopUp" [style]="{width: '30vw'}" class="popUpHeader">
    <p>All the ADC and EHR data records calculated together.</p>
</p-dialog>
